const DirectorMessage = () => {
  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-white to-sub/20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-primary mb-3 sm:mb-4">
            <strong>院長挨拶</strong>
          </h2>
          <p className="text-gray-600 text-sm sm:text-base">
            皆様の健康と笑顔のために
          </p>
        </div>

        <article className="bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 sm:gap-8 md:gap-10 p-6 sm:p-8 md:p-12">
            <div className="lg:col-span-2 flex flex-col items-center">
              <div className="w-full max-w-xs aspect-[3/4] rounded-2xl overflow-hidden mb-4 sm:mb-6">
                <img
                  src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/beb6caac6d7d05a93b72d36fbb12a7cf.jpeg"
                  alt="院長 岡山太郎"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="text-center">
                <p className="text-gray-600 text-xs sm:text-sm mb-1">院長</p>
                <h3 className="font-serif text-xl sm:text-2xl text-primary font-bold">岡山 太郎</h3>
                <p className="text-gray-500 text-xs sm:text-sm mt-2">
                  国家資格（はり師・きゅう師）
                </p>
              </div>
            </div>

            <div className="lg:col-span-3 flex flex-col justify-center">
              <div className="space-y-4 sm:space-y-6">
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  この度は、<strong>おかやま鍼灸院</strong>のホームページをご覧いただき、誠にありがとうございます。院長の<strong>岡山太郎</strong>と申します。
                </p>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  当院は<strong>2000年</strong>の開業以来、<strong>岡山市北区</strong>の地域の皆様の健康をサポートさせていただいております。<strong>東洋医学の伝統的な知恵</strong>と<strong>現代医学の知識</strong>を融合させ、一人ひとりの患者様に寄り添った<strong>オーダーメイドの治療</strong>を心がけております。
                </p>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  <strong>肩こり</strong>、<strong>腰痛</strong>、<strong>頭痛</strong>などの身体の不調から、<strong>自律神経の乱れ</strong>、<strong>ストレス</strong>による症状まで、幅広く対応いたします。また、<strong>美容鍼</strong>や<strong>スポーツ鍼灸</strong>など、健康増進や美容のサポートも行っております。
                </p>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  患者様が笑顔で健やかな毎日を過ごせるよう、スタッフ一同、真心を込めて施術させていただきます。お体のことで気になることがございましたら、どうぞお気軽にご相談ください。
                </p>
                <div className="pt-4 sm:pt-6">
                  <p className="text-right text-gray-600 text-sm sm:text-base font-serif">
                    おかやま鍼灸院 院長　<strong className="text-primary text-lg sm:text-xl">岡山 太郎</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default DirectorMessage;
